import { TUserRole } from 'api/unions'
import { array, string, type } from 'io-ts'

export const TRegisterResult = type({
  email: string,
  role: TUserRole,
  scopes: array(string),
  userId: string,
})
